// actions.js
import * as actionTypes from "./actionsTypes"

export const setValueFxFacturation = newValue => ({
  type: actionTypes.SET_VALUE_FX_FACTURATION,
  payload: newValue,
})

export const setCurrentPageFxFacturation = newCurrentPage => ({
  type: actionTypes.SET_CURRENT_PAGE_FX_FACTURATION,
  payload: newCurrentPage,
})

export const setPageSizeFxFacturation = newValue => ({
  type: actionTypes.SET_PAGE_SIZE_FX_FACTURATION,
  payload: newValue,
})
export const setSortingFxFacturation = newValue => ({
  type: actionTypes.SET_SORTING_FX_FACTURATION,
  payload: newValue,
})
export const setCustomFilterFxFacturation = newValue => ({
  type: actionTypes.SET_CUSTOM_FILTERS_FX_FACTURATION,
  payload: newValue,
})
export const setSortFieldFxFacturation = newSortField => ({
  type: actionTypes.SET_SORT_FIELD_FX_FACTURATION,
  payload: newSortField,
})
export const setOrderFxFacturation = newOrder => ({
  type: actionTypes.SET_ORDER_FX_FACTURATION,
  payload: newOrder,
})
export const setActiveTabFxFacturation = newActiveTab => ({
  type: actionTypes.SET_ACTIVE_TAB_FX_FACTURATION,
  payload: newActiveTab,
})
export const setPageHistoriqueFxFacturation = newActiveTab => ({
  type: actionTypes.SET_PAGE_HISTORIQUE_HM_FX_FACTURATION,
  payload: newActiveTab,
})
export const setPagePaiementFxFacturation = newActiveTab => ({
  type: actionTypes.SET_PAGE_PAIEMENT_HM_FX_FACTURATION,
  payload: newActiveTab,
})
export const setIdFxFacturation = newActiveTab => ({
  type: actionTypes.SET_ID_FX_FACTURATION,
  payload: newActiveTab,
})
export const setColumnFxFacturation = newValue => ({
  type: actionTypes.SET_COLUMN_FX_FACTURATION,
  payload: newValue,
})
//
export const setQueryFxFacturation = newQuery => ({
  type: actionTypes.SET_QUERY_FX_FACTURATION,
  payload: newQuery,
})
export const setActifFxFacturation = newQuery => ({
  type: actionTypes.SET_ACTIF_FX_FACTURATION,
  payload: newQuery,
})
export const setSelectedOptionFiltersFxFacturation = newQuery => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_FX_FACTURATION,
  payload: newQuery,
})
export const setSelectedOptionIdFxFacturation = newQuery => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_FX_FACTURATION,
  payload: newQuery,
})
